export default "__VITE_ASSET__ffabf993__"